export const OVERRIDE_RATES_PRODUCT_LINE_SECTION_TEST_ID = 'override-rates-product-line-section';
export const OVERRIDE_RATES_PRODUCT_LINE_HEADER_TEST_ID = 'override-rates-product-line-header';
